import { render, staticRenderFns } from "./RevisionLogTypeSelect.vue?vue&type=template&id=9256fbf0&scoped=true&lang=pug"
import script from "./RevisionLogTypeSelect.vue?vue&type=script&lang=js"
export * from "./RevisionLogTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9256fbf0",
  null
  
)

export default component.exports